/* eslint-disable indent */
/* eslint-disable no-useless-escape */
/* eslint-disable no-throw-literal */
/* eslint-disable max-len */
/* eslint-disable indent */

import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EquipmentHeader from '../../views/Equipments/EquipmentHeader';
import Loader from '../Common/Loader/Loader';
import GenericForm from '../Common/GenericForm/GenericForm';
import { BodyContainer } from './EquipmentDetails.styles';
import { useActions } from '../../store/hooks/useActions';
import { apiEndPoints } from '../../services/axios/endPoints';
import { WebService } from '../../services/axios/webServices';
import { sagaCatchBlockHandling } from '../../store/utility/sagaErrorHandling';
import {
  convertFormInputObjToSimple,
  getFieldDependents,
  validateFields
} from '../Common/GenericForm/utils';
import { isEmpty } from '../../shared/utility/isEmpty';
import { INPUT_TYPES } from '../../constants';
import Toast from '../Common/Toast';

const EquipmentDetailsForm = () => {
  const locations = useLocation();
  const navigate = useNavigate();
  const { state } = locations;

  const equipmentDetailsFormRef = useRef();

  const [loading, setLoading] = useState(false);
  const [formInput, setFormInput] = useState({});
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [userSavePermissionInfo, setUserSavePermissionInfo] = useState({});
  const [equipmentformStructure, setEquipmentformStructure] = useState([]);
  const { equipmentPermissions } = useSelector(
    (state) => state.equipmentDetails
  );

  const { setToastError } = useActions();

  const {
    isFormEditable,
    isFormChangePass = false,
    formInput: formInputProp,
    areFormInputsChanged,
    formApi,
    saveForm
  } = state;

  const isEdit = saveForm === `${apiEndPoints.updateEquipment}/update`;

  useEffect(() => {
    if (isFormChangePass) {
      setLoading(true);
      WebService.get(`${formApi}/${formInputProp?.UserID}`)
        .then((res) => {
          const { status, data } = res;
          if (status >= 200 && status < 300) {
            setEquipmentformStructure(data);
          } else {
            throw res.data;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          setToastError(error);
        })
        .finally(() => {
          setLoading(false);
        });
      setFormInput(formInputProp);
    } else {
      setLoading(true);
      WebService.get(formApi)
        .then((res) => {
          const { status, data } = res;
          if (status >= 200 && status < 300) {
            setEquipmentformStructure(data);
          } else {
            throw res.data;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          setToastError(error);
        })
        .finally(() => {
          setLoading(false);
        });
      setFormInput(formInputProp);
    }
    // }
  }, [formInputProp]);

  useEffect(() => {
    equipmentformStructure?.forEach((user) => {
      if (Object.keys(user)?.includes('isSave')) {
        if (user?.isSave) {
          setUserSavePermissionInfo({ ...user });
        }
      }
    });
  }, [equipmentformStructure]);

  const handleEquipmentEdit = () => {
    navigate('/home/Equipment/edit', {
      state: {
        isFormEditable: true,
        formInput,
        formApi: `${apiEndPoints.getEquipmentForm}/UpdateEquipmentForm`,
        saveForm: `${apiEndPoints.updateEquipment}/update`
      }
    });
  };

  const handleSave = () => {
    const localFormInput = equipmentDetailsFormRef.current.getFormInput();
    try {
      const isPassed = validateFields(equipmentformStructure, localFormInput);
      if (!isPassed) {
        throw 'Validation error has occurred';
      }
      // console.log('localFormInput', localFormInput);
      const formatedFormInput = convertFormInputObjToSimple(localFormInput);
      const requiredInput = equipmentformStructure.reduce((acc, e) => {
        const { key, inputType, defaultValue } = e;
        let val =
          formatedFormInput[key] === undefined
            ? defaultValue
            : formatedFormInput[key];
        if (inputType === INPUT_TYPES.TOGGLE) {
          val = val || false;
        }
        if (!key) return acc;
        // if (key === 'RoleId') return { ...acc, [key]: val, Roles: formatedFormInput.Roles };
        return { ...acc, [key]: val };
      }, {});
      WebService.post(saveForm, requiredInput)
        .then((res) => {
          const { data, status } = res;
          if (status >= 200 && status < 300) {
            setFormInput(localFormInput);
            navigate('/home/Equipment', {
              state: {
                isFormEditable: false,
                formInput: localFormInput,
                areFormInputsChanged: true,
                formApi,
                saveForm
              }
            });
          } else {
            throw res;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          console.log('error===', error);
          setToastError(error);
        });
    } catch (e) {
      console.log('error--', e);
      setToastError(e);
    }
  };

  const handleCancel = () => {
    if (isEdit) {
      navigate('/home/Equipment/details', {
        state: {
          isFormEditable: false,
          formInput: formInputProp,
          formApi,
          saveForm
        }
      });
    } else {
      navigate('/home/Equipment', {
        state: { record: areFormInputsChanged ? formInput : {} }
      });
    }
  };

  const handleBack = () => {
    // if in details page go back to users
    if (!isFormEditable) {
      navigate('/home/Equipment', {
        state: { record: areFormInputsChanged ? formInput : {} }
      });
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <EquipmentHeader
        title={
          !isFormEditable
            ? 'Equipment details'
            : `${isEdit ? 'Edit' : 'Add'} Equipment Details`
        }
        isFormEditable={isFormEditable}
        handleEquipmentEdit={handleEquipmentEdit}
        handleSave={handleSave}
        isSaveEnabled={
          !isEmpty(userSavePermissionInfo)
            ? userSavePermissionInfo?.isSave === 'Y' && isFormFilled
            : isFormFilled
        }
        handleCancel={handleCancel}
        canEdit={equipmentPermissions?.CanEdit}
        handleBack={handleBack}
      />
      <BodyContainer>
        {loading ? (
          <Loader />
        ) : (
          <GenericForm
            isFormEditable={isFormEditable}
            formStructure={equipmentformStructure}
            ref={equipmentDetailsFormRef}
            formInput={formInput}
            setFormInput={setFormInput}
            showHeader
            setIsFormFilled={setIsFormFilled}
            formStructureFieldDepenents={getFieldDependents(
              equipmentformStructure
            )}
            allowHorizontal={false}
            isUser={true}
          />
        )}
        {!isEmpty(userSavePermissionInfo) &&
          userSavePermissionInfo?.isSave !== 'Y' && (
            <Toast
              message={userSavePermissionInfo?.displayMsg || ''}
              header='Error'
              style={{ right: 30, bottom: 30 }}
            />
          )}
      </BodyContainer>
    </>
  );
};

export default EquipmentDetailsForm;
